/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { get } from 'lodash';

export default ({ color }) => ({
  TagGroup: {
    height: '24px',
    whiteSpace: 'nowrap',
    width: '100%',
  },
  Tag: {
    border: `1px solid ${get(color, 'borderColor', '#C8D1E0')}`,
    color: get(color, 'link'),
    fontSize: 12,
    marginRight: 4,
    padding: '2px',
  },
});



// WEBPACK FOOTER //
// ./src/components/TagsGroup/index.theme.js